<template>
  <span>
    <i v-if="unknown" class="fas fa-question text-warning traffic-light-icon"></i>
    <i v-if="pass === true" class="fas fa-check text-success traffic-light-icon"></i>
    <i v-if="!pass" class="fas fa-times text-danger traffic-light-icon"></i>
  </span>
</template>

<script>
export default {
  props: ['pass'],
  computed: {
    unknown () {
      return this.pass === 'unknown' || (this.pass !== true && this.pass)
    }
  }
}
</script>
